import { render, staticRenderFns } from "./NotAllowed.vue?vue&type=template&id=437cbad6&scoped=true&"
import script from "./NotAllowed.vue?vue&type=script&lang=ts&"
export * from "./NotAllowed.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "437cbad6",
  null
  
)

export default component.exports